"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const notificationsbrand04 = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 58 72",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-notificationsbrand04` : '') + (description ? ` desc-notificationsbrand04` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-notificationsbrand04"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-notificationsbrand04"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M36.306 65.267a1.504 1.504 0 0 1 1.865-1.013 1.494 1.494 0 0 1 1.02 1.856c-.944 3.195-3.892 5.39-7.24 5.39-3.35 0-6.298-2.195-7.241-5.39a1.494 1.494 0 0 1 1.019-1.856 1.504 1.504 0 0 1 1.866 1.013 4.536 4.536 0 0 0 4.355 3.243 4.536 4.536 0 0 0 4.356-3.243Zm-4.363-61.54a1.5 1.5 0 0 1 1.503 1.495v6.479l-.002.05c11.292.767 20.213 10.12 20.213 21.545 0 18.462 3.597 22.994 4.244 23.66l.054.054.045.04H5.886s4.343-5.516 4.343-23.754c0-11.425 8.92-20.778 20.213-21.544a.442.442 0 0 1-.002-.051V5.222a1.5 1.5 0 0 1 1.503-1.495Z",
    fill: "#F1C4DC",
    fillOpacity: ".5"
  }), /*#__PURE__*/_react.default.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#D01481"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.852 60.753a1 1 0 0 1 1.242.675c.63 2.126 2.604 3.596 4.855 3.596 2.251 0 4.224-1.47 4.855-3.596a1 1 0 1 1 1.917.568c-.884 2.986-3.645 5.028-6.772 5.028-3.126 0-5.887-2.042-6.772-5.028a1 1 0 0 1 .675-1.243ZM27.942.307a1 1 0 0 1 1 1v6.472a1 1 0 1 1-2 0V1.307a1 1 0 0 1 1-1Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M27.942 8.779c-11.482 0-20.773 9.22-20.773 20.573 0 9.188-1.098 15.22-2.219 18.983-.497 1.67-1 2.893-1.411 3.748H52.15c-.377-.707-.797-1.668-1.211-2.96-1.13-3.53-2.225-9.574-2.225-19.771 0-11.354-9.292-20.573-20.773-20.573Zm26.77 43.538a4.317 4.317 0 0 1-.48-.629c-.355-.558-.865-1.544-1.388-3.175-1.047-3.27-2.13-9.091-2.13-19.161 0-12.476-10.204-22.573-22.772-22.573-12.569 0-22.773 10.098-22.773 22.573 0 9.031-1.08 14.865-2.136 18.412-.528 1.773-1.05 2.974-1.43 3.719-.189.372-.343.63-.444.789a3.968 3.968 0 0 1-.132.194l-.002.002a1 1 0 0 0 .79 1.614h52.254a1 1 0 0 0 .643-1.765Zm-52.898.766-.785-.62-.001.002-.001.001-.001.002c0-.002.002-.004.004-.006l.784.62Z"
  })));
};
var _default = exports.default = notificationsbrand04;